/// <reference path="../../_references.ts"/>

module App.ItemManagement {
	import Appointment = App.Appointments.Appointment;
	import Questionnaire = App.Questionnaire.Questionnaire;
	import QuestionnaireToken = App.Questionnaire.QuestionnaireToken;
	import QuestionnaireTokenCreate = App.Questionnaire.QuestionnaireTokenCreate;
	import TitleBarService = App.Helpers.TitleBarService;
	import UploadService = App.Helpers.UploadService;
	import OrganizationFileUploadData = App.Utils.OrganizationFileUploadData;

	export class ItemDetailsController {
		static $inject: string[] = [
			'$q', '$scope', '$state', '$timeout',
			'FormService', 'ItemManagementService', 'QuestionnaireService', 'SelectedAppointment',
			'TitleBarService', 'UploadService', 'OrganizationService', 'DefaultToasts'
		];

		loading: boolean = true;
		appointment: Appointment = null;
		item: ServiceableItem = null;
		itemType: ServiceableItemType = null;
		organization: OrganizationFileUploadData = null;

		edittedItem: ServiceableItem = null;
		editItemFlyout: boolean = false;

		edittedNote: ServiceableItemNote = null;
		editNoteFlyout: boolean = false;

		edittedPhoto: ServiceableItemImage = null;
		editPhotoFlyout: boolean = false;
		isSavingPhoto: boolean = false;
		errorFile: Object = {};

		hasForms: boolean;

		instances: App.Forms.FormInstanceList[];
		tags: ServiceableItemTag[] = null;
		tagOptions: TagOption[][] = [];

		showMdl: boolean = true;

		constructor(
			protected $q: ng.IQService,
			protected $scope: ng.IScope,
			protected $state: ng.ui.IStateService,
			protected $timeout: ng.ITimeoutService,
			protected FormService: App.Forms.FormService,
			protected ItemManagementService: ItemManagementService,
			protected QuestionnaireService: App.Questionnaire.QuestionnaireService,
			protected SelectedAppointment: App.Appointments.SelectedAppointment,
			protected TitleBarService: TitleBarService,
			protected UploadService: UploadService,
			protected OrganizationService: App.Utils.OrganizationService,
			protected DefaultToasts: App.Utils.DefaultToasts,
		) {
			TitleBarService.set('Appointment');

			this.$q.all({
				appointment: SelectedAppointment.getAppointment(),
				organization: OrganizationService.getFileUploadDetails(),
				tags: this.ItemManagementService.GetServiceableItemTags(),
				item: this.ItemManagementService.GetServiceableItem($state.params.itemId),
				itemType: this.ItemManagementService.getItemTypeForItem($state.params.itemId),
				instances: this.FormService.getItemInstances($state.params.itemId),
				forms: this.FormService.getForms({ for_item: $state.params.itemId, item_form: 1, size: 0 })
			}).then((data) => {
				this.appointment = data.appointment;
				this.organization = data.organization.data;
				this.tags = data.tags.data;
				this.item = data.item.data;
				this.itemType = data.itemType.data;
				this.instances = data.instances.data;
				this.hasForms = Number(data.forms.headers('count')) > 0;

				if (this.item.installed_on != null) {
					this.item.installed_on = moment(this.item.installed_on).toDate();
				}
				this.edittedItem = angular.copy(this.item);

				this.loading = false;
				this.upgradeMdlInputs();
			});
		}

		getSelectedValueForTag(tag: ServiceableItemTag): string {
			let item = <TagOption>this.item['tag_' + (tag.tag_group + 1)];
			return item ? tag.options[item.index] : null;
		}

		getValuesForTag(tag: ServiceableItemTag): TagOption[] {
			if (this.tagOptions[tag.tag_group]) {
				return this.tagOptions[tag.tag_group];
			}

			return this.tagOptions[tag.tag_group] = tag.options.filter((value) => {
				return value !== null && value !== '';
			}).map((value, index) => {
				return {
					index: index,
					value: value
				};
			});
		}

		createForm(form: Questionnaire) {
			const vm = this;

			const questionnaireToken : QuestionnaireTokenCreate = {
				service_request: vm.appointment.service_request.id,
				questionnaire: form.id,
				serviceable_item: vm.edittedItem.id
			};

			vm.QuestionnaireService.CreateQuestionnaireToken(questionnaireToken).then((response) => {
				vm.$state.go('zipSolutions.questionnaire.item', { itemId: vm.item.id, formId: response.data.id });
			});
		}

		openOrClosed(questionnaire: QuestionnaireToken) {
			const status = questionnaire.service_request.service_request_status;

			if (status === 'Closed' || status === 'Deleted' || status === 'Cancelled') {
				return 'Closed';
			}

			return 'Open';
		}

		editItemDetails() {
			const vm = this;
			vm.editItemFlyout = true;
		}

		saveItemDetails() {
			const vm = this;

			vm.ItemManagementService.UpdateServiceableItem(vm.edittedItem).then((response) => {
				vm.item = new ServiceableItem(response.data);
				vm.editItemFlyout = false;
				vm.upgradeMdlInputs();
			});
		}

		editNote(note: ServiceableItemNote) {
			const vm = this;

			vm.edittedNote = note;
			vm.editNoteFlyout = true;
		}

		saveNote(note: ServiceableItemNote) {
			const vm = this;

			if(!note) {
				vm.editNoteFlyout = false;
				return;
			}

			note.service_request = this.appointment.service_request.id;

			var promise: ng.IHttpPromise<ServiceableItemNote> =
				note.id ?
					vm.ItemManagementService.UpdateServiceableItemNote(vm.item.id, note)
					: vm.ItemManagementService.CreateServiceableItemNote(vm.item.id, note);

			promise.then(() => {
				vm.editNoteFlyout = false;
				vm.ItemManagementService.GetServiceableItemNotes(vm.item.id).then((response) => {
					vm.item.notes = response.data;
				});
			});
		}

		clearNote(note: ServiceableItemNote) {
			const vm = this;

			if(!note || !note.id) {
				vm.editNoteFlyout = false;
				return;
			}

			vm.ItemManagementService.DeleteServiceableItemNote(vm.item.id, note.id).then(() => {
				vm.ItemManagementService.GetServiceableItemNotes(vm.item.id).then((response) => {
					vm.item.notes = response.data;
				});
				vm.editNoteFlyout = false;
			});
		}

		editPhoto(image: ServiceableItemImage) {
			const vm = this;

			vm.edittedPhoto = image;
			vm.editPhotoFlyout = true;
		}

		displayDate(date: Date) {
			if(!date) {
				return '';
			}
			return moment(date).format('YYYY-MM-DD');
		}

		displayMaxSizeError() {
			this.DefaultToasts.displayWarning('Reduce File Size and Try Again');
			this.errorFile = {};
		};

		uploadImage(files: File[]) {
			const vm = this;

			if (vm.item.id) {
				if (files && files.length) {
					for (let i = 0; i < files.length; i++) {
						vm.isSavingPhoto = true;
						vm.UploadService.upload('serviceableitem/' + vm.item.id + '/image', files[i]).then(function (response: any) {
							vm.item.images = response.data;
						}).finally(() => {
							vm.isSavingPhoto = false;
						});
					}
				}


			}
		};

		deleteImage(image: ServiceableItemImage) {
			const vm = this;

			if (vm.item.id) {
				vm.ItemManagementService.DeleteServiceableItemImage(vm.item.id, image.id).then((response) => {
					vm.item.images = response.data;
				});
			}
		};

		setImg() {
			angular.element(document.querySelector('#image-upload')).triggerHandler('click');
		};

		upgradeMdlInputs() {
			 const vm = this;
			 vm.showMdl = false;
			 vm.$timeout(() => {
			 	vm.showMdl = true;
				vm.$timeout(() => {
					componentHandler.upgradeAllRegistered();
				})
			 });
		}
	}
}